import { AppBar, Toolbar, Stack, Box, Typography } from "@mui/material";

export default function Header() {
    return (
        <AppBar position="relative" component="nav" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ width: '100%' }}
                >
                    <Box>
                        <Stack direction="row" spacing={2} justifyContent="flex-start" alignItems="center" >
                            <Box component={'img'} src='/ah-icon.svg' />
                            <Typography variant="h6" >
                                Visa Faktura
                            </Typography>
                        </Stack>
                    </Box>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}